import { tassign } from 'tassign';
import { ApiResponseState, initialApiResponseState } from './api-response-state.model';
import { ApiResponseActions, Action } from './api-response-actions';

/**
* @function ApiResponseReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
* @return {tassing<ApiResponseState>} Value with the store
**/
export const ApiResponseReducer = function (state: ApiResponseState = initialApiResponseState, action: Action): ApiResponseState {
  switch (action.type) {
    case ApiResponseActions.SET_SUB_RES:
      return action.payload.type === 'wifi' ?
        tassign(state, { wifiSubscription: action.payload.response, apiAction: action.payload.apiAction }) :
        tassign(state, { packageSubscription: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_SUB_STATE:
      return tassign(state, {
        subscriptionComplete: action.payload.state, apiAction: action.payload.apiAction
      });
    case ApiResponseActions.SET_VINLIST:
      return tassign(state, { apiAction: action.payload.apiAction, vinlist: action.payload.response });
    case ApiResponseActions.SET_PREVIEW:
      return tassign(state, { preview: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_CUSTOMER:
    case ApiResponseActions.SET_UPDATE_CUSTOMER:
      return tassign(state, { customer: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_SUBSCRIPTION_HISTORY_CUSTOMER:
      return tassign(state, { subscriptionHistoryCustomer: action.payload, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_SUBSCRIBED_CUSTOMER:
      return tassign(state, { subscribedCustomer: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_REMOTE_CUSTOMER:
      return tassign(state, { remoteCustomer: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_REMOTE_COMMAND:
      return tassign(state, { remoteCommand: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_FIND_VEHICLE:
      return tassign(state, { findVehicle: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_METADATA:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_WIFI_STATUS:
      return tassign(state, { wifiState: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_SUBSCRIPTION_HISTORY:
      return tassign(state, { subscriptionHistory: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_CUSTOMER_HISTORY:
      return tassign(state, { customerHistory: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.RESET_API_STORE:
      return tassign(state, { apiAction: '' });
    case ApiResponseActions.SET_VERIFY_ADDRESS:
      return tassign(state, { verifyAddress: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_GET_PROVISIONING:
      return tassign(state, { getProvisioning: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_RETRIGER_PROVISIONING:
      return tassign(state, { retrigerProvisioning: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_PROVISION_HISTORY:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_TCI_REPORT:
      return tassign(state, { tciReport: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_SXM_REPORT:
      return tassign(state, { sxmReport: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_TELEMATICS_REPORT:
      return tassign(state, { telematicsReport: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_REJECTS:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_VCM_TOKEN:
      return tassign(state, { vcmTokenResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_VCM_HISTORY:
      return tassign(state, { vcmHistoryResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_CLEAR_VIN:
      return tassign(state, { vcmClearResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_BLACKLIST_VIN:
      return tassign(state, { vcmBlacklistResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_CLEAR_CHIP_ID:
      return tassign(state, { vcmClearChipIdResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.UPDATE_FANDA:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_UPDATE_EMERGENCY_CONTACT:
      return tassign(state, { updateEmergencyContact: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_EMERGENCY_CONTACT:
      return tassign(state, { emergencyContact: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_PARTIAL_FACTORY_DATA_FEED:
      return tassign(state, { partialFactoryDataFeed: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_FULL_FACTORY_DATA_FEED:
      return tassign(state, { fullFactoryDataFeed: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_AIR_DATA_FEED:
      return tassign(state, { airDataFeed: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_USER_ROLE:
      return tassign(state, { userRole: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_USER_ROLE_UPDATE:
      return tassign(state, { userRoleUpdate: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_USER_DELETE:
      return tassign(state, { userDelete: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_ZUORA_CUSTOMER:
      return tassign(state, { zuoraResponse: action.payload.response, apiAction: action.payload.apiAction });
    // CMS
    case ApiResponseActions.SET_CMS_CREATE_TICKET:
      return tassign(state, { cmsCreateTicketResponse: action.payload.response, apiAction: action.payload.apiAction });
    // TSS
    case ApiResponseActions.SET_TSS:
      return tassign(state, { tssResponse: action.payload.response, apiAction: action.payload.apiAction });
    // PHONE COMPATIBILITIES
    case ApiResponseActions.SET_PHONE_CONFIG:
      return tassign(state, { phoneConfigResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_PHONE_COMPATIBILITIES:
      return tassign(state, { phoneCompatibilitiesResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_GUID_STATUS:
      return tassign(state, { guidStatus: action.payload.response, apiAction: action.payload.apiAction });
    // DEALER DETAILS
    case ApiResponseActions.SET_HOME_DEALER:
      return tassign(state, { homeDealer: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_PREFERRED_DEALER:
      return tassign(state, { preferredDealer: action.payload.response, apiAction: action.payload.apiAction });
    // OUTAGE BANNER
    case ApiResponseActions.SET_OUTAGE_BANNER_MESSAGE:
      return tassign(state, { outageBanner: action.payload.response, apiAction: action.payload.apiAction });
    // VEHICLE HISTORY
    case ApiResponseActions.SET_VEHICLE_HISTORY:
      return tassign(state, { vehicleHistory: action.payload.response, apiAction: action.payload.apiAction });
    // PRODUCT PACKAGES
    case ApiResponseActions.SET_PRODUCT_PACKAGES:
      return tassign(state, { productPackages: action.payload.response, apiAction: action.payload.apiAction });
    // TRIAL LENGTHS
    case ApiResponseActions.SET_TRIAL_LENGTHS:
      return tassign(state, { trialLengthsResponse: action.payload.response, apiAction: action.payload.apiAction });
    // LINKED ACCOUNTS
    case ApiResponseActions.SET_LINKED_ACCOUNTS:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    // 21MM USER PROFILE SETTINGS
    case ApiResponseActions.SET_21MM_USER_PROFILE_SETTINGS:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    // Digital Key card
    case ApiResponseActions.SET_LOOKUP_KEY:
      return tassign(state, { lookupKeys: action.payload.response, apiAction: action.payload.apiAction });
    // Goodwill packages
    case ApiResponseActions.SET_GOODWILL_PACKAGES:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SUBMIT_GOODWILL_PACKAGES:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    // Data Consents
    case ApiResponseActions.GET_DATA_CONSENTS:
      return tassign(state, { dataConsentsResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.GET_SMS_CONSENT:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });   
    // Update Remote User
    case ApiResponseActions.SET_UPDATE_REMOTE_USER:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    case ApiResponseActions.SET_SURVIVOR_ACCOUNT:
      return tassign(state, { survivorAccount: action.payload.response, apiAction: action.payload.apiAction });
    // Set PnC Status
    case ApiResponseActions.SET_PNC_STATUS:
      return tassign(state, { apiResponse: action.payload.response, apiAction: action.payload.apiAction });
    default:
      return state;
  }
};
